export default {
  spendField: 'spend_ltd',
  interpolateMonths: true,
  trendMetrics: []
};



// WEBPACK FOOTER //
// ./src/app/configuration/CapitalOne/config/components/scorecard/Trendchart/index.js